/**
 * StorageAdapter.ts - StorageAdapter - Abstract storage interface
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
export class StorageAdapter {
  /**
   * Initialize storage
   */
  async initialize() {
    throw new Error('initialize() must be implemented by subclass');
  }

  /**
   * Store an entity
   * @param {string} entityType - Type of entity
   * @param {string} id - Entity ID
   * @param {Object} data - Entity data
   * @returns {Promise<Object>} Stored entity
   */
  async set(entityType: string, id: string, data): Promise<any> {
    throw new Error('set() must be implemented by subclass');
  }

  /**
   * Retrieve an entity
   * @param {string} entityType - Type of entity
   * @param {string} id - Entity ID
   * @returns {Promise<Object|null>} Entity or null if not found
   */
  async get(entityType: string, id: string): Promise<any | null> {
    throw new Error('get() must be implemented by subclass');
  }

  /**
   * Delete an entity
   * @param {string} entityType - Type of entity
   * @param {string} id - Entity ID
   * @returns {Promise<boolean>} True if deleted
   */
  async delete(entityType: string, id: string): Promise<boolean> {
    throw new Error('delete() must be implemented by subclass');
  }

  /**
   * Query entities
   * @param {string} entityType - Type of entity
   * @param {Object} filters - Query filters
   * @returns {Promise<Array<Object>>} Matching entities
   */
  async query(entityType: string, filters: Record<string, any> = {}): Promise<any[]> {
    throw new Error('query() must be implemented by subclass');
  }

  /**
   * Get all entities of a type
   * @param {string} entityType - Type of entity
   * @returns {Promise<Array<Object>>} All entities
   */
  async getAll(entityType: string): Promise<any[]> {
    throw new Error('getAll() must be implemented by subclass');
  }

  /**
   * Clear all data
   * @returns {Promise<void>}
   */
  async clear() {
    throw new Error('clear() must be implemented by subclass');
  }
}

export default StorageAdapter;
